{
  "version": 1,
  "asset_id": "6f72177c-d055-4088-9e26-ae578a1a6d78",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/6f72177c-d055-4088-9e26-ae578a1a6d78/clip-img_2161.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/6f72177c-d055-4088-9e26-ae578a1a6d78/clip-img_2161.mp4",
  "original_filename": "clip-img_2161.mp4",
  "size": 164492,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:52Z"
}
